const HesGotTheWholeWorldInHisHands = [
	'[Verse 1]',
	"He's got the whole world in His hands",
	"He's got the whole world in His hands",
	"He's got the whole world in His hands",
	"He's got the whole world in His hands",
	'',
	'[Verse 2]',
	"He's got the wind and rain in His hands",
	"He's got the wind and rain in His hands",
	"He's got the wind and rain in His hands",
	"He's got the whole world in His hands",
	'',
	'[Verse 3]',
	"He's got the little tiny baby in his hands",
	"He's got the little tiny baby in his hands",
	"He's got the little tiny baby in his hands",
	"He's got the whole world in His hands",
	'',
	'[Verse 4]',
	"He's got you and me, brother, in his hands",
	"He's got you and me, brother, in his hands",
	"He's got you and me, brother, in his hands",
	"He's got the whole world in His hands",
	'',
	'[Verse 5]',
	"He's got you and me, sister, in his hands",
	"He's got you and me, sister, in his hands",
	"He's got you and me, sister, in his hands",
	"He's got the whole world in His hands",
	'',
	'[Verse 6]',
	"He's got everybody here, in his hands",
	"He's got everybody here, in his hands",
	"He's got everybody here, in his hands",
	"He's got the whole world in His hands",
];

export default HesGotTheWholeWorldInHisHands;
